import {
  JsonConfiguration2bv2x41u8reet as JsonConfiguration,
  ClassDiscriminatorMode_POLYMORPHIC_getInstance2mrsp68rtcatm as ClassDiscriminatorMode_POLYMORPHIC_getInstance,
} from './JsonConfiguration.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DescriptorSchemaCache22yqwocbp420v as DescriptorSchemaCache } from './internal/SchemaCache.mjs';
import { JsonToStringWriter25agxcyem0yhk as JsonToStringWriter } from './internal/JsonToStringWriterJsWasm.mjs';
import { encodeByWriter108llwage8l5s as encodeByWriter } from './internal/JsonStreams.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { StringJsonLexer3eu6xom7mrcfu as StringJsonLexer } from './internal/StringJsonLexer.mjs';
import { WriteMode_OBJ_getInstance1vxozndswhwrl as WriteMode_OBJ_getInstance } from './internal/WriteMode.mjs';
import { StreamingJsonDecoderyo05rsghf9i6 as StreamingJsonDecoder } from './internal/StreamingJsonDecoder.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { JsonSerializersModuleValidator1v682i122jgoa as JsonSerializersModuleValidator } from './internal/JsonSerializersModuleValidator.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends Json() {
      constructor() {
        Default_instance = null;
        super(new (JsonConfiguration())(), EmptySerializersModule());
        Default_instance = this;
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new (Default())();
  return Default_instance;
}
var JsonClass;
function Json() {
  if (JsonClass === VOID) {
    class $ {
      constructor(configuration, serializersModule) {
        Default_getInstance();
        this.s27_1 = configuration;
        this.t27_1 = serializersModule;
        this.u27_1 = new (DescriptorSchemaCache())();
      }
      mz() {
        return this.t27_1;
      }
      v27(serializer, value) {
        var result = new (JsonToStringWriter())();
        try {
          encodeByWriter(this, result, serializer, value);
          return result.toString();
        }finally {
          result.y27();
        }
      }
      w27(deserializer, string) {
        var lexer = StringJsonLexer(this, string);
        var input = new (StreamingJsonDecoder())(this, WriteMode_OBJ_getInstance(), lexer, deserializer.az(), null);
        var result = input.qz(deserializer);
        lexer.l28();
        return result;
      }
    }
    initMetadataForClass($, 'Json');
    JsonClass = $;
  }
  return JsonClass;
}
function Json_0(from, builderAction) {
  from = from === VOID ? Default_getInstance() : from;
  var builder = new (JsonBuilder())(from);
  builderAction(builder);
  var conf = builder.e29();
  return new (JsonImpl())(conf, builder.d29_1);
}
var JsonBuilderClass;
function JsonBuilder() {
  if (JsonBuilderClass === VOID) {
    class $ {
      constructor(json) {
        this.m28_1 = json.s27_1.f29_1;
        this.n28_1 = json.s27_1.k29_1;
        this.o28_1 = json.s27_1.g29_1;
        this.p28_1 = json.s27_1.h29_1;
        this.q28_1 = json.s27_1.j29_1;
        this.r28_1 = json.s27_1.l29_1;
        this.s28_1 = json.s27_1.m29_1;
        this.t28_1 = json.s27_1.o29_1;
        this.u28_1 = json.s27_1.v29_1;
        this.v28_1 = json.s27_1.q29_1;
        this.w28_1 = json.s27_1.r29_1;
        this.x28_1 = json.s27_1.s29_1;
        this.y28_1 = json.s27_1.t29_1;
        this.z28_1 = json.s27_1.u29_1;
        this.a29_1 = json.s27_1.p29_1;
        this.b29_1 = json.s27_1.i29_1;
        this.c29_1 = json.s27_1.n29_1;
        this.d29_1 = json.mz();
      }
      e29() {
        if (this.c29_1) {
          // Inline function 'kotlin.require' call
          if (!(this.t28_1 === 'type')) {
            var message = 'Class discriminator should not be specified when array polymorphism is specified';
            throw IllegalArgumentException().a1(toString(message));
          }
          // Inline function 'kotlin.require' call
          if (!this.u28_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
            var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
            throw IllegalArgumentException().a1(toString(message_0));
          }
        }
        if (!this.q28_1) {
          // Inline function 'kotlin.require' call
          if (!(this.r28_1 === '    ')) {
            var message_1 = 'Indent should not be specified when default printing mode is used';
            throw IllegalArgumentException().a1(toString(message_1));
          }
        } else if (!(this.r28_1 === '    ')) {
          var tmp0 = this.r28_1;
          var tmp$ret$7;
          $l$block: {
            // Inline function 'kotlin.text.all' call
            var inductionVariable = 0;
            while (inductionVariable < charSequenceLength(tmp0)) {
              var element = charSequenceGet(tmp0, inductionVariable);
              inductionVariable = inductionVariable + 1 | 0;
              if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
                tmp$ret$7 = false;
                break $l$block;
              }
            }
            tmp$ret$7 = true;
          }
          var allWhitespaces = tmp$ret$7;
          // Inline function 'kotlin.require' call
          if (!allWhitespaces) {
            var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.r28_1;
            throw IllegalArgumentException().a1(toString(message_2));
          }
        }
        return new (JsonConfiguration())(this.m28_1, this.o28_1, this.p28_1, this.b29_1, this.q28_1, this.n28_1, this.r28_1, this.s28_1, this.c29_1, this.t28_1, this.a29_1, this.v28_1, this.w28_1, this.x28_1, this.y28_1, this.z28_1, this.u28_1);
      }
    }
    initMetadataForClass($, 'JsonBuilder');
    JsonBuilderClass = $;
  }
  return JsonBuilderClass;
}
function validateConfiguration($this) {
  if (equals($this.mz(), EmptySerializersModule()))
    return Unit_instance;
  var collector = new (JsonSerializersModuleValidator())($this.s27_1);
  $this.mz().r1k(collector);
}
var JsonImplClass;
function JsonImpl() {
  if (JsonImplClass === VOID) {
    class $ extends Json() {
      constructor(configuration, module_0) {
        super(configuration, module_0);
        validateConfiguration(this);
      }
    }
    initMetadataForClass($, 'JsonImpl');
    JsonImplClass = $;
  }
  return JsonImplClass;
}
//region block: exports
export {
  Json_0 as Jsonsmkyu9xjl7fv,
};
//endregion

//# sourceMappingURL=Json.mjs.map
